/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    loadGooglePayClientId,
    clearGooglePayClientId,
} from './GooglePay-Actions';
import initialState from '../../../../initialState';

const googlePayReducer = (state = initialState.payment.googlePay, action) => {
    switch (action.type) {
        case loadGooglePayClientId().type:
            return {
                ...state,
                clientToken: action.data,
            };
        case clearGooglePayClientId().type:
            return {
                ...state,
                clientToken: '',
            };
        default:
            return state;
    }
};

export default googlePayReducer;
